import { library } from '@fortawesome/fontawesome-svg-core';
import { 
    faEnvelope, 
    faHeadset, 
    faComments, 
    faUser, 
    faPhone, 
    faCalendarAlt, 
    faClock, 
    faComment, 
    faSpinner, 
    faCheck, 
    faTimes, 
    faArrowRight, 
    faCheckCircle, 
    faExclamationCircle,
    faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { 
    faInstagram, 
    faLinkedin 
} from '@fortawesome/free-brands-svg-icons';

// Add only the icons we use to the library
library.add(
    // Solid icons
    faEnvelope,
    faHeadset,
    faComments,
    faUser,
    faPhone,
    faCalendarAlt,
    faClock,
    faComment,
    faSpinner,
    faCheck,
    faTimes,
    faArrowRight,
    faCheckCircle,
    faExclamationCircle,
    faChevronDown,
    // Brand icons
    faInstagram,
    faLinkedin
); 